import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Spinner } from "@/components/common";
import { EmailTags } from "@/pages/Reports";

export function RedirectDialog({ failure, onClose, onDone }) {
  const [to, setTo] = useState([]);
  const m = useMutation({
    mutationFn: () => api.post(`/delivery/email/${failure.id}/redirect`, { to }).then((r) => r.data),
    onSuccess: (d) => { d.status === "sent" ? toast.success(`Resent to ${d.to.join(", ")}`) : toast.error(`Resend failed: ${d.error}`); onDone(); onClose(); },
    onError: (e) => toast.error(errMsg(e)),
  });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111827] border-[#2d3d58] max-w-lg" data-testid="redirect-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Resend to another address</DialogTitle>
          <DialogDescription className="text-slate-400 text-xs">Sends the same <b>{failure.kind_label}</b> (“{failure.subject}”) to the addresses below. The original recipient was <span className="font-mono">{failure.recipient}</span>.</DialogDescription>
        </DialogHeader>
        <div>
          <label className="eyebrow block mb-1.5">Recipients</label>
          <EmailTags testId="redirect-emails-input" value={to} onChange={setTo} />
          <p className="text-[11px] text-slate-500 mt-1">Press Enter or comma after each address. Sandbox mode still applies.</p>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={onClose}>Cancel</Button>
          <Button data-testid="redirect-confirm-button" size="sm" className="bg-blue-600 hover:bg-blue-500" disabled={m.isPending || !to.length} onClick={() => m.mutate()}>{m.isPending ? <Spinner className="text-white" /> : `Resend to ${to.length || 0} address${to.length === 1 ? "" : "es"}`}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
